import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createCharacter(_, character) {
    const response = await axios.post('/blade/characters', character);
    return response.data.character;
  },
  async getCharacters() {
    const response = await axios.get('/blade/characters');
    return response.data.characters;
  },
  async getCharacter(_, { characterId }) {
    const { data } = await axios.get(`/blade/characters/${characterId}`);
    return data;
  },
  async getCharacterVoice(_, { characterId }) {
    const { data } = await axios.get(`/blade/characters/${characterId}/voice`);
    return data.character;
  },
  async getCharacterEnums() {
    const { data } = await axios.get('/blade/characterEnums');
    return data;
  },
  async updateCharacter(_, character) {
    const response = await axios.patch(`/blade/characters/${character._id}`, character);
    return response.data.character;
  },
  async copyCharacterToCentralDb(_, characterOrId) {
    const id = characterOrId._id || characterOrId;
    const response = await axios.post(`/blade/characters/${id}/centralize`);
    return response.data;
  },
  async deleteCharacter(_, { characterId, _id }) {
    const did = characterId || _id;
    const response = await axios.delete(`/blade/characters/${did}`);
    return response.data.character;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/characters.js